<template>
  <div class="animated fadeIn">
    <div class="card">
      <div class="card-header">
        Danh sách giải trí
        <div class="card-header-actions"></div>
      </div>
      <div class="card-body">
        <div class="text-left">
          <b-collapse
            v-bind:visible="mData.tableRules.showFormSearch"
            id="myFormSearch"
          >
            <b-card>
              <el-form
                ref="myForm"
                label-position="top"
                @submit.native.prevent
                :model="mData.tableRules.dataSearch.value"
                :rules="mData.tableRules.dataSearch.valid"
              >
                <b-row>
                  <b-col md="4">
                    <el-form-item label="Tên dịch vụ" prop="">
                      <el-input
                        v-model="
                          mData.tableRules.dataSearch.value['giai_tri.ten']
                        "
                        clearable
                        placeholder="Nhập từ khóa (nhấn enter để tìm kiếm)"
                      >
                      </el-input>
                    </el-form-item>
                  </b-col>
                </b-row>
                <el-form-item class="text-center mb-0">
                  <el-button
                    type="info"
                    native-type="submit"
                    v-ladda
                    plain
                    @click="fn_tableSearch()"
                    >{{ aLang.c_search }}</el-button
                  >
                </el-form-item>
              </el-form>
            </b-card>
          </b-collapse>
        </div>
        <b-row>
          <b-col :class="'col-md-8'">
            <div class="text-left mb-0">
              <b-row>
                <b-col md="4">
                  <el-select
                    v-model="mData.tableRules.dataSearch.value.ngon_ngu"
                    :placeholder="'Ngôn ngữ'"
                    @change="fn_tableSearch()"
                    :default-first-option="true"
                    clearable
                    filterable
                    v-if="this.mData.currentUser.roles.includes('Officer')"
                  >
                    <el-option
                        v-for="item in mData.dataDefault.listNgonNgu"
                        :key="item.id"
                        :label="item.name"
                        :value="item.id"
                      ></el-option>
                  </el-select>
                </b-col>
                <b-col md="4">
                  <el-select
                    v-model="mData.tableRules.dataSearch.value.visible"
                    :placeholder="'Trạng thái hiển thị'"
                    @change="fn_tableSearch()"
                    :default-first-option="true"
                    clearable
                    filterable
                    v-if="this.mData.currentUser.roles.includes('Officer')"
                  >
                    <el-option
                      v-for="item in mData.dataDefault.trangThai"
                      :key="item.code"
                      :label="item.text"
                      :value="item.code"
                    ></el-option>
                  </el-select>
                </b-col>
              </b-row>
            </div>
          </b-col>
          <b-col :class="'col-md-4'">
            <div class="text-right mb-2">
              <el-button @click="fn_tableShowFormSearch()" type="info" plain>{{
                aLang.c_showHideSearch
              }}</el-button>
            </div>
          </b-col>
        </b-row>
        <el-table
          :data="mData.tableRules.data"
          border
          @selection-change="fn_tableSelectionChange"
          @sort-change="fn_tableSortChange"
          max-height="440"
          style="width: 100%;"
          :default-sort="{
            prop: mData.tableRules.defaultSort[0],
            order: mData.tableRules.defaultSort[1],
          }"
        >
          <el-table-column
            type="selection"
            width="40"
            v-if="mData.tableRules.allowSelect"
          ></el-table-column>
          <el-table-column label="STT" width="50">
            <template slot-scope="scope">
              <div class="text-center">
                {{ mData.tableRules.offset + scope.$index + 1}}
              </div>
            </template>
          </el-table-column>
          <el-table-column
            prop="giai_tri.ten"
            label="Tên dịch vụ"
            :sortable="mData.tableRules.allowSorting"
          >
            <template slot-scope="scope">
              <el-link
                class="cell-child"
                target="_blank"
                @click="fn_handle('detail',scope.$index, scope.row)"
                :underline="false"
              >{{scope.row.giai_tri.ten}}</el-link>
            </template>
          </el-table-column>
          <el-table-column
            v-if="
              mData.currentUser.roles.includes('Officer') ||
              mData.currentUser.roles.includes('Admin')
            "
            prop="diem_den_an_toan.thong_tin_chung.ten"
            label="Tên đơn vị"
            :sortable="mData.tableRules.allowSorting"
          >
            <template slot-scope="scope">
              <span>{{
                scope.row.diem_den_an_toan.thong_tin_chung.ten
              }}</span>
            </template>
          </el-table-column>
          <el-table-column
            prop="visible"
            width="150px"
            label="Trạng thái hiển thị"
            :sortable="mData.tableRules.allowSorting"
          >
            <template slot-scope="scope">
              <div class="text-center">{{
                scope.row.visible == true ? "Hiển thị" : "Đang ẩn"
              }}</div>
            </template>
          </el-table-column>
          <el-table-column
            prop="ngon_ngu"
            label="Ngôn ngữ"
            :sortable="mData.tableRules.allowSorting"
            width="120px"
          >
            <template slot-scope="scope">
              <div class="text-center">
                {{scope.row.ngon_ngu == "vi" ? 'Tiếng Việt' : scope.row.ngon_ngu == "en" ? 'Tiếng Anh' : ''}}
              </div>
            </template>
          </el-table-column>
          <el-table-column :label="aLang.c_action" align="center" width="200px">
            <template slot-scope="scope">
              <el-button
                size="mini"
                @click="fn_handle('detail', scope.$index, scope.row)"
                v-b-popover.hover.left="aLang.c_detail"
              >
                <i class="fa fa-eye"></i>
              </el-button>
              <el-button
                size="mini"
                @click="fn_handle('update', scope.$index, scope.row)"
                v-b-popover.hover.left="aLang.c_update"
              >
                <i class="icon-pencil icons"></i>
              </el-button>
              <el-button
                size="mini"
                @click="fn_handle('unApproved', scope.$index, scope.row)"
                v-b-popover.hover.left="aLang.c_unApproved"
                v-if="
                  mData.currentUser.roles.includes('Officer') ||
                  mData.currentUser.roles.includes('Admin')
                "
              >
                <i class="fas fa-ban"></i>
              </el-button>
              <el-button
                size="mini"
                @click="fn_handle('delete', scope.$index, scope.row)"
                v-b-popover.hover.left="aLang.c_delete"
              >
                <i class="icon-trash icons"></i>
              </el-button>
            </template>
          </el-table-column>
        </el-table>

        <b-row class="mt-2" v-if="mData.tableRules.allowPaging">
          <div class="col-md-4">
            <div v-if="mData.tableRules.allowSelect">
              {{ aLang.c_select }}: {{ mData.tableRules.recordSelected.length }}
            </div>
          </div>
          <div class="col-md-8 text-right">
            <el-pagination
              @size-change="fn_tableSizeChange"
              @current-change="fn_tableCurentChange"
              @prev-click="fn_tablePrevClick"
              @next-click="fn_tableNextClick"
              :page-sizes="mData.tableRules.lengthMenu"
              :page-size="mData.tableRules.limit"
              :current-page="mData.tableRules.page"
              background
              layout="total, sizes, prev, pager, next, jumper"
              :total="mData.tableRules.total"
              :pager-count="5"
            ></el-pagination>
          </div>
        </b-row>
      </div>
    </div>
    <ModalSelectDonViCungCap
      @submit="gotoCreateDonViCungCap"
      :configModal="mData.showFormAdd"
    />
  </div>
</template>

<script>
import LanguageService from "../../../service/LanguageService";
import DataService from '@/service/DataService';
import DichVuApi from "@/moduleApi/DichVuApi";
import DDATApi from "@/moduleApi/DDATApi";
import DonViCungCapApi from "@/moduleApi/DonViCungCapApi";
import MethodService from "../../../service/MethodService";
import VuiChoiGiaiTriModel from '@/views/admin/VuiChoiGiaiTri/VuiChoiGiaiTriModel';
import ModalSelectDonViCungCap from "./ModalSelectDonViCungCap";
export default {
  components: {
    ModalSelectDonViCungCap,
  },
  data() {
    return {
      aLang: LanguageService.lang,
      mData: {
        showFormAdd: {
          show: false,
        },
        moduleName: "VuiChoiGiaiTri", //requied
        tableRules: MethodService.copyObject(VuiChoiGiaiTriModel.tableRules),
        dataDefault: {
          trangThai: [
            {
              code: "",
              text: "Tất cả",
            },
            {
              code: "true",
              text: "Hiển thị",
            },
            {
              code: "false",
              text: "Ẩn",
            },
          ],
          listNgonNgu: DataService.Languages,
          listHienThi: DataService.visibleList,
        },
        currentUser: JSON.parse(localStorage.getItem("currentUser")),
        ifHavePermission: false,
        ifHaveCreate: false,
      },
    };
  },
  created() {
    if (
      this.mData.currentUser.roles.includes("Officer") ||
      this.mData.currentUser.roles.includes("Admin")
    ) {
      this.mData.ifHavePermission = false;
    } else if (this.mData.currentUser.roles.includes("SafePlace")) {
      this.mData.ifHavePermission = true;
    }
    this.fn_hashUrl();
    this.getListEntertainment();
  },
  mounted() {
    this.mData.tableRules.dataSearch.value.visible = "";
  },
  methods: {
    async fn_checkServiceExist(diem_den_an_toan_id) {
      const res = await DichVuApi.list({
        filters: [
          "loai=entertainment",
          "diem_den_an_toan_id=" + diem_den_an_toan_id,
        ],
      });
      if (res.result.length) {
        return res.result[0];
      } else {
        return null;
      }
    },
    async gotoCreateDonViCungCap(DonVi) {
      const dataCheck = await this.fn_checkServiceExist(DonVi.donViCungCapId);
      if (dataCheck) {
        this.$router.push({
          name: "Admin-" + this.mData.moduleName + "-update",
          params: { id: dataCheck.id },
        });
        return;
      }
      this.mData.showFormAdd.show = false;
      this.$router.push({
        name: "Admin-" + this.mData.moduleName + "-create-admin",
        params: { id: DonVi.donViCungCapId },
      });
    },
    async getListEntertainment() {
      let dataFilter = {
        filters: (this.mData.tableRules.filters ? this.mData.tableRules.filters + "&" : "") + "loai=entertainment",
      };

      if (this.mData.tableRules.allowPaging) {
        dataFilter.limit = this.mData.tableRules.limit;
        dataFilter.offset = this.mData.tableRules.offset;
      }
      if (this.mData.tableRules.allowSorting) {
        dataFilter.sort = this.mData.tableRules.sort;
      }

      if (this.mData.tableRules.showUrl) {
        this.$router
          .replace({
            name: "Admin-" + this.mData.moduleName + "-list",
            query: {
              limit: this.mData.tableRules.limit,
              page: this.mData.tableRules.page,
              sort: this.mData.tableRules.sort,
              filters: this.mData.tableRules.filters,
              showFormSearch: this.mData.tableRules.showFormSearch,
            },
          })
          .catch(() => {});
      }

      const res = await DichVuApi.list(dataFilter);
      let resData = await this.fn_changeData(res.result);
      let diemDenAnToanIds = res.result.map((id) => id.diem_den_an_toan_id);
      let arrDiemDenAnToanIds = MethodService.findListItemDifferent(
        diemDenAnToanIds
      );

      let resDiemDenAnToan = await DDATApi.list({
        filters: "id:in:" + arrDiemDenAnToanIds.join(","),
      });
      resData.forEach((item) => {
        item.diem_den_an_toan = resDiemDenAnToan.result.find(
          (x) => x.id == item.diem_den_an_toan_id
        );
        let address = "";
        if (item.diem_den_an_toan.thong_tin_chung.dia_chi.dia_chi) {
          address += item.diem_den_an_toan.thong_tin_chung.dia_chi.dia_chi;
        }
        if (item.diem_den_an_toan.thong_tin_chung.dia_chi.xa) {
          address += " - " + item.diem_den_an_toan.thong_tin_chung.dia_chi.xa;
        }
        if (item.diem_den_an_toan.thong_tin_chung.dia_chi.huyen) {
          address +=
            " - " + item.diem_den_an_toan.thong_tin_chung.dia_chi.huyen;
        }
        if (item.diem_den_an_toan.thong_tin_chung.dia_chi.tinh) {
          address += " - " + item.diem_den_an_toan.thong_tin_chung.dia_chi.tinh;
        }
        item.diem_den_an_toan.thong_tin_chung.dia_chi.dia_chi = address;
      });

      let resDonViCungCap = await DonViCungCapApi.list({
        filters: "id:in:" + arrDiemDenAnToanIds.join(","),
      });
      resData.forEach((item) => {
        item.dich_vu = resDonViCungCap.result.find(
          (x) => x.id == item.diem_den_an_toan_id
        );
      });

      //end get name
      this.mData.tableRules.data = resData;
      this.mData.tableRules.total = res.meta.total;
      this.mData.tableRules.page = res.meta.offset / res.meta.limit + 1;
      if (
        this.mData.tableRules.offset == res.meta.total &&
        this.mData.tableRules.offset != 0
      ) {
        this.mData.tableRules.offset = 0;
        this.mData.tableRules.page = 1;
        this.getListEntertainment();
      }
    },

    //xử lý dữ liệu đầu ra
    async fn_changeData(resData) {
      return resData;
    },

    //event table
    fn_tableSelectionChange(val) {
      let _this = this;
      this.mData.tableRules.recordSelected = [];
      val.forEach(function (element) {
        _this.mData.tableRules.recordSelected.push(element.id);
      });
    },

    fn_tableSortChange(column) {
      if (column.order == "ascending") {
        this.mData.tableRules.sort = column.prop;
      } else if (column.order == "descending") {
        this.mData.tableRules.sort = "-" + column.prop;
      } else {
        this.mData.tableRules.sort = "";
      }
      this.getListEntertainment();
    },
    // search
    fn_tableSearch() {
      this.$refs["myForm"].validate(async (valid) => {
        if (valid && !this.mData.dataDefault.validErrorTime) {
          this.mData.tableRules.filters = MethodService.filterTable(
            JSON.stringify(this.mData.tableRules.dataSearch)
          );
          this.mData.tableRules.offset = 0;
          this.mData.tableRules.sort = "";
          this.getListEntertainment();
        } else {
          MethodService.stopLadda();
          return false;
        }
      });
    },

    //event table
    fn_tableSizeChange(limit) {
      this.mData.tableRules.limit = limit;
      this.fn_tableChangeOffset(this.mData.tableRules.page);
    },
    fn_tableCurentChange(page) {
      this.fn_tableChangeOffset(page);
    },
    fn_tablePrevClick(page) {
      this.fn_tableChangeOffset(page);
    },
    fn_tableNextClick(page) {
      this.fn_tableChangeOffset(page);
    },

    fn_tableChangeOffset(page) {
      this.mData.tableRules.page = page;
      this.mData.tableRules.offset =
        (this.mData.tableRules.page - 1) * this.mData.tableRules.limit;
      this.getListEntertainment();
    },

    fn_tableShowFormSearch() {
      this.mData.tableRules.showFormSearch = !this.mData.tableRules
        .showFormSearch;
      let query = Object.assign({}, this.$route.query);
      query.showFormSearch = this.mData.tableRules.showFormSearch;
      this.$router.push({
        name: "Admin-" + this.mData.moduleName + "-list",
        query: query,
      });
    },

    async fn_handle(type, scope, row) {
      if (type == "create-admin") {
        this.mData.showFormAdd.show = true;
      }
      if (type == "update") {
        // if (this.mData.currentUser.roles.includes("SafePlace")) {
        //   const tempService = await DichVuChoDuyetApi.list({
        //     filters: this.mData.tableRules.filters + "loai=entertainment",
        //     limit: this.mData.tableRules.limit,
        //     offset: this.mData.tableRules.offset,
        //   });
        //   if (tempService.result.length) {
        //     let data = tempService.result[0];
        //     data.giai_tri = row.giai_tri;
        //     await DichVuChoDuyetApi.update(data);
        //     this.$router.push({
        //       name: "Admin-" + this.mData.moduleName + "-update-history",
        //       params: { id: data.id },
        //     });
        //   } else {
        //     const create = await DichVuChoDuyetApi.create({
        //       loai: "entertainment",
        //       giai_tri: row.giai_tri,
        //     });
        //     this.$router.push({
        //       name: "Admin-" + this.mData.moduleName + "-update-history",
        //       params: { id: create.result },
        //     });
        //   }
        //   return;
        // }
        this.$router.push({
          name: "Admin-" + this.mData.moduleName + "-update",
          params: { id: row.id },
        });
      }
      if (type == "detail") {
        this.$router.push({
          name: "Admin-" + this.mData.moduleName + "-detail",
          params: { id: row.id },
        });
      }
      if (type == "refuse") {
        this.$router.push({
          name: "Admin-" + this.mData.moduleName + "-refuse",
          params: { id: row.id },
        });
      }
      if (type == "unApproved") {
        this.$confirm(LanguageService.lang.c_unApproveConfirm, {
          confirmButtonText: LanguageService.lang.c_agree,
          cancelButtonText: LanguageService.lang.c_cancel,
          type: "warning"
        }).then(() => {
          this.fn_unApproved(row.id);
        }).catch(() => {});
      }
      if (type == "delete") {
        this.$confirm(LanguageService.lang.c_deleteConfirm, {
          confirmButtonText: LanguageService.lang.c_agree,
          cancelButtonText: LanguageService.lang.c_cancel,
          type: "warning",
        })
          .then(() => {
            this.fn_delete(row.id);
          })
          .catch(() => {});
      }
    },

    async fn_delete(id) {
      await DichVuApi.delete(id);
      this.getListEntertainment();
    },
    async fn_unApproved(id) {
      await DichVuApi.unApprovedDichVu(id);
      this.getListEntertainment();
    },
    fn_hashUrl() {
      if (this.$route.query.limit) {
        this.mData.tableRules.limit = parseInt(this.$route.query.limit);
      }
      if (this.$route.query.page) {
        this.mData.tableRules.page = parseInt(this.$route.query.page);
      }
      if (this.$route.query.limit && this.$route.query.page) {
        this.mData.tableRules.offset =
          (this.mData.tableRules.page - 1) * this.mData.tableRules.limit;
      }
      if (this.$route.query.sort) {
        this.mData.tableRules.sort = this.$route.query.sort;
        this.mData.tableRules.defaultSort[0] = this.mData.tableRules.sort;
        if (this.mData.tableRules.sort.indexOf("-") != -1) {
          this.mData.tableRules.defaultSort[1] = "descending";
        } else {
          this.mData.tableRules.defaultSort[1] = "ascending";
        }
      }
      if (this.$route.query.filters) {
        this.mData.tableRules.filters = this.$route.query.filters;
        // string to object
        this.mData.tableRules.dataSearch.value = MethodService.stringToObject(
          this.mData.tableRules.filters
        );
      }
      if (this.$route.query.showFormSearch == "true") {
        this.mData.tableRules.showFormSearch = true;
      }
      if (this.$route.query.showFormSearch == "false") {
        this.mData.tableRules.showFormSearch = false;
      }
    },
  },
};
</script>

<style scope>
.text-css {
  display: -webkit-box;
  -webkit-line-clamp: 1;
  -webkit-box-orient: vertical;
  overflow: hidden;
}
.text-css p {
  margin: 0;
}
</style>
